import React from 'react';
import './informationsection.scss';

type InfoSectionProps = {
    message: string;
};

const InfoSection = (props: InfoSectionProps) => {
    const { message } = props;

    return (
        <div className="info-section">
            <p className="info-description">
                <span className='info-icon'>&#9888;</span>
                <span>{message}</span>
            </p>
    </div >
  );
};

export default InfoSection;
